import { Routes, Route } from 'react-router-dom'
import IdLayout from './layouts/IdLayout'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import OnboardingPage from './pages/OnboardingPage'
import DashboardPage from './pages/DashboardPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import ContactPage from './pages/ContactPage'
import CookiePolicyPage from './pages/CookiePolicyPage'
import OAuthCallbackPage from './pages/OAuthCallbackPage'
import DeviceApprovePage from './pages/DeviceApprovePage'
import CookieConsent from './components/CookieConsent'
import LivingIdentityBackground from './components/LivingIdentityBackground'
import { lazy, Suspense } from 'react'

const PortalPage = lazy(() => import('./pages/PortalPage'))

function App() {
  return (
    <>
      {/* Deep space base layer */}
      <div className="fixed inset-0 z-[-20]" style={{ background: 'rgb(5, 8, 15)' }} />
      {/* Living teal particle canvas — persists across route transitions */}
      <LivingIdentityBackground opacity={0.60} zIndex={-5} />
      <Routes>
        {/* Mode A (Stealth Luxury) - public pages */}
        <Route element={<IdLayout brandMode="A" />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/cookies" element={<CookiePolicyPage />} />
        </Route>

        {/* Mode B (Technical Museum) - authenticated pages */}
        <Route element={<IdLayout brandMode="B" />}>
          <Route path="/dashboard" element={<DashboardPage />} />
        </Route>

        {/* Onboarding - focused flow, no shared layout */}
        <Route path="/auth/onboarding" element={<OnboardingPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />

        {/* OAuth callback — Google/GitHub redirect flow + SSO token handler */}
        <Route path="/oauth/callback" element={<OAuthCallbackPage />} />

        {/* Device approval — opens on phone when QR is scanned; no shared layout */}
        <Route path="/device-approve" element={<DeviceApprovePage />} />

        {/* Gated Portal — controlled access entry point */}
        <Route path="/portal" element={<Suspense fallback={null}><PortalPage /></Suspense>} />
      </Routes>
      <CookieConsent />
    </>
  )
}

export default App
